// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__uUn2U","unreadBadge":"styles_unreadBadge__1vhsX","modalContent":"styles_modalContent__3kBb7","modal":"styles_modal__-amMA"};